<template>
  <b-list-group flush class="mb-6">
    <b-list-group-item
      action
      class="cursor-pointer"
      @click="showSwal('primary')"
    >
      <b-row align-v="center">
        <b-col md="auto" class="pl-0">
          <!-- Avatar -->
          <div
            class="rounded-full w-10 h-10  flex justify-center items-center  bg-primary-tranparent"
          >
            <feather-icon
              icon="GlobeIcon"
              class="text-primary"
              svgClasses="w-4"
            ></feather-icon>
          </div>
        </b-col>
        <b-col class="pl-0">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h4 class="mb-0 text-sm font-semibold">Universe</h4>
              <p class="text-xs text-muted font-normal mb-0">
                #Brained-suite
              </p>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-list-group-item>

    <!-- <b-list-group-item action class="cursor-pointer">
      <b-row align-v="center">
        <b-col md="auto" class="pl-0">

          <div
            class="rounded-full w-10 h-10  flex justify-center items-center  bg-primary-tranparent"
          >
            <feather-icon
              icon="CompassIcon"
              class="text-primary"
              svgClasses="w-4"
            ></feather-icon>
          </div>
        </b-col>
        <b-col class="pl-0">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h4 class="mb-0 text-sm font-semibold">Discover</h4>
              <p class="text-xs text-muted font-normal mb-0">
                #Brained-suite
              </p>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-list-group-item> -->
  </b-list-group>
</template>
<script>
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
export default {
  methods: {
    showSwal(type) {
      if (type === "primary") {
        swal.fire({
          title: `Work in Progress`,
          text: "We are working to offer you the best experience",
          // buttonsStyling: false,
          showCancelButton: false,
          cancelButtonColor: "",
          confirmButtonClass: "btn btn-primary bg-primary",
          confirmButtonText: "OK",
          cancelButtonText: "No",
          icon: "info"
        });
      }
    }
  }
};
</script>
